import React from 'react';

import styled from 'styled-components';

import Label, { Props as LabelProps } from 'components/Label';

export interface LabelStyledProps extends LabelProps {
  styledProps: {
    hasError: boolean;
  };
}

export const FieldLabel = styled(({ styledProps, ...rest }: LabelStyledProps) => <Label {...rest} />)`
  ${({ theme, styledProps }) => {
    if (styledProps.hasError) {
      return `color: ${theme.field.color}`;
    } else {
      return `color: ${theme.group.section.details}`;
    }
  }}
`;
